



























































































import Vue from 'vue';
import CommunityProfileMainData from '@/web/components/community/CommunityProfileMainData';
import { mapGetters } from 'vuex';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  name: 'CommunityProfilePreview',
  components: {
    CommunityProfileMainData,
  },
  props: {
    user: {
      type: Object as () => CommunityProfileResponse,
      default: null,
    },
    size: {
      type: String,
      default: 'medium',
    },
  },
  computed: {
    ...mapGetters({
      currentUserId: 'user/studentCommunityProfileId',
      studioCommunityProfileId: 'user/studioCommunityProfileId',
      studio: 'studio/currentStudio',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
    isStudioProfile() {
      return this.user?.id == this.studioCommunityProfileId;
    },
    primaryColor() {
      return this.studio?.primary_color;
    },
  },
  data() {
    return {
      userInfo: {},
      sendMessageLinkActive: true,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch(`user/logout`);
    },
    isCurrentUser() {
      return this.user.id === this.currentUserId;
    },
    async createPrivateChatRoom() {
      try {
        this.sendMessageLinkActive = false;
        this.$emit('close');
        const privateRoom = await this.$store.dispatch(
          'community/createPrivateChatRoom',
          {
            studioURL: this.studioURL,
            member: this.user.id,
          }
        );
        this.sendMessageLinkActive = true;
        await this.redirectToChat(privateRoom.id);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1,
        });
      }
    },
    async redirectToChat(roomId) {
      this.$router.push({
        name: 'studio-community-chat',
        params: {
          studio_url: this.studioURL,
        },
        query: {
          room_id: roomId,
        },
      });
    },
  },
  async mounted() {
    this.userInfo = await this.$store.dispatch('community/loadUserData', {
      studioURL: this.studioURL,
      uuid: this.user.id,
    });
  },
});
